import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  GetRegisterNumberingDto,
  CreateUpdateRegisterNumberingDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { registerNumberingForGrid } from '../../../spd/components/RegisterNumbering/RegisterNumbering';

export interface RegisterNumberingContextInterface {
  findByHealthcareFacilityIdByPortion: (
    healthcareFacilityId: string,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  findByHealthcareFacilityIdCount: (
    healthcareFacilityId: string,
    filterText?: string,
  ) => Promise<number>;
  create: (
    data: CreateUpdateRegisterNumberingDto,
  ) => Promise<GetRegisterNumberingDto[]>;
}

export const RegisterNumberingContext = (api: DefaultApi) => {
  return {
    findByHealthcareFacilityIdByPortion: async (
      healthcareFacilityId: string,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data =
        await api.registerNumberingControllerFindByHealthcareFacilityId(
          healthcareFacilityId,
          pageSize,
          pageNumber,
          orderBy || '',
          orderDirection || '',
          filterText || '',
        );
      return data.map(registerNumberingForGrid);
    },

    findByHealthcareFacilityIdCount: async (
      healthcareFacilityId: string,
      filterText?: string,
    ) => {
      return api.registerNumberingControllerGetByHealthcareFacilityIdCount(
        healthcareFacilityId,
        filterText,
      );
    },

    create: async (data: CreateUpdateRegisterNumberingDto) => {
      return api.registerNumberingControllerCreate(data);
    },
  };
};

export const NewRegisterNumbering = (healthcareFacilityId?: string) => {
  return {
    healthcareFacilityId,
    registerIds: [],
    symbolDoctor: '',
    symbolPsychological: '',
    activeFrom: new Date(),
  };
};
